export class TruckSequence {
  id: number;
  inYardSequenceNum: number;
  newRowNum: number;
  object: string;
  wasMoved: boolean;

  constructor() {
    this.object = 'truckSequence';
    this.wasMoved = false;
  }
}

export class TruckSequencesUpdate {
  plantId: number;
  trucks: Array<TruckSequence>;
  object = 'truckSequenceUpdate';
}
